import './FloatingAlert.css';

const FloatingAlert = ({ message, type }) => {
  if (!message) return null;

  return (
    <div className={`floating-alert floating-alert-${type}`}>
      {message}
    </div>
  );
};

export default FloatingAlert;
